module.exports = __webpack_public_path__ + "static/media/lotA_synthese-CCHE_10_V.5fb34fb3.webp";